import React from "react"
import { parseISO } from "date-fns"

interface RecurringFieldsProps {
	register: any
	watch: (name: string) => any
	errors: Record<string, any>
	className?: string
	titleNoun?: string
}

/**
 * Champs de gestion de récurrence pour un formulaire d'absence.
 * À utiliser dans un formulaire react-hook-form.
 */
export const RecurringFields: React.FC<RecurringFieldsProps> = ({
	register,
	watch,
	errors,
	className = "",
	titleNoun = "l'absence"
}) => (
	<div className={`form-control border rounded p-4 bg-base-100 ${className}`}>
		<label className="flex items-center gap-2 cursor-pointer">
			<input
				type="checkbox"
				className="checkbox"
				{...register("is_recurring")}
			/>
			<span>Est-ce que {titleNoun} se répète ?</span>
		</label>

		{watch("is_recurring") && (
			<div className="mt-4 space-y-4">
				<div>
					<label className="label">
						<span className="label-text">Répétition</span>
					</label>
					<select
						className="select select-bordered w-full"
						{...register("recurring_period")}
						defaultValue="everyweek"
					>
						<option value="everyday">Tous les jours</option>
						<option value="everyweek">Toutes les semaines</option>
						<option value="everymonth">Tous les mois</option>
					</select>
				</div>
				<div>
					<label className="label">
						<span className="label-text">Se termine le</span>
					</label>
					<select
						className="select select-bordered w-full"
						{...register("recurring_end_type")}
						defaultValue="school_year_end"
					>
						<option value="school_year_end">Fin d'année scolaire</option>
						<option value="custom_date">Date personnalisée</option>
					</select>
				</div>
				{watch("recurring_end_type") === "custom_date" && (
					<div>
						<label className="label">
							<span className="label-text">Date de fin de récurrence</span>
						</label>
						<input
							type="date"
							className={`input input-bordered w-full ${errors.recurring_end_date ? "input-error" : ""}`}
							{...register("recurring_end_date", {
								setValueAs: (value: string) => {
									if (!value) return undefined
									return parseISO(value)
								},
							})}
						/>
						{errors.recurring_end_date && (
							<div className="text-error mt-1">{errors.recurring_end_date.message}</div>
						)}
					</div>
				)}
			</div>
		)}
	</div>
)

export default RecurringFields
